import Field from "@/app/core/layouts/main-components/input/Field";
import { OnDataChange } from "@/app/core/util/helpers/FieldHelper";
import { FieldTypeObj } from "@/app/core/util/helpers/FieldTypeHelper";
import { UserHelper } from "@/app/core/util/helpers/UserHelper";
import React, { useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export default function SignIn(props) {
    const [step, setStep] = useState(0);
    const [route, setRoute] = useState(0);
    const [loading, setLoading] = useState(0);
    const [data, setData] = useState({});

    function processRoute(i) {
        setRoute(i);
        let level = 0;
        if (step === 1) {
            level = UserHelper.UserLevel.User;
        } else if (step === 2) {
            level = UserHelper.UserLevel.Company;
        }
        setData({ ...data, level });
    }

    function handleChange(evt, type){
        setData(OnDataChange(data, evt, type))
    }

    function steps() {
        switch (route) {
            case 1:
                return (
                    <div>
                        <form
                            className="js-validation-signin"
                            onSubmit={(e) => registerUser(e)}
                        >
                            <p className="text-center text-uppercase text-muted">
                                Cadastro de usuário
                            </p>
                            <div className="py-3">
                                <Field
                                    name="name"
                                    onChange={(evt) => handleChange(evt)}
                                    title={"Nome"}
                                    value={data && data.name}
                                    type={FieldTypeObj.Text}
                                />
                                <Field
                                    name="email"
                                    onChange={(evt) => handleChange(evt)}
                                    title={"Email"}
                                    value={data && data.email}
                                    type={FieldTypeObj.Text}
                                />
                                <Field
                                    name="password"
                                    onChange={(evt) => handleChange(evt)}
                                    title={"Senha"}
                                    value={data && data.password}
                                    type={FieldTypeObj.Password}
                                />
                                <Field
                                    name="phone"
                                    onChange={(evt) =>
                                        handleChange({
                                            target: {
                                                name: evt.target.name,
                                                value: evt.target.value.replace(/[^\d]+/g, ""),
                                            },
                                        })
                                    }
                                    title={"Telefone"}
                                    value={data && data.phone}
                                    type={FieldTypeObj.Mask}
                                    mask={"(99) 99999-99999"}
                                />
                            </div>
                            <div className="form-group">
                                <button
                                    type="submit"
                                    className="btn btn-block btn-hero-lg btn-hero-warning"
                                >
                                    <i
                                        className={
                                            loading === true
                                                ? "fa fa-circle-notch fa-spin"
                                                : "fa fa-fw fa-sign-in-alt mr-1"
                                        }
                                    />{" "}
                                    Cadastrar
                                </button>
                                <p className="mt-3 mb-0 text-center">
                                    <a
                                        className="btn btn-sm btn-dual mb-3 btn-block d-lg-inline-block mb-1"
                                        onClick={() => setRoute(0)}
                                    >
                                        <i className="fa fa-arrow-left text-muted mr-1" /> Voltar
                                    </a>
                                    <a
                                        className="btn btn-sm btn-light btn-block d-lg-inline-block mb-1"
                                        onClick={() => (window.location = "#/auth")}
                                    >
                                        <i className="fa fa-plus text-muted mr-1" /> Ja tem conta?
                                        Login
                                    </a>
                                </p>
                            </div>
                        </form>
                    </div>
                );
            default:
                return "";
        }
    }

    function registerUser(e){
        e.preventDefault();

    }

    return (
        <div id="page-container">
            <main id="main-container">
                <div>
                    <div className="row no-gutters bg-primary-op">
                        <div className="hero-static col-md-6 d-flex align-items-center bg-white">
                            <div className="p-3 w-100">
                                <div className="mb-3 text-center">
                                    <a
                                        className="link-fx font-w700 font-size-h1"
                                        href="javascript:void()"
                                    >
                                        <img
                                            src={process.env.PUBLIC_URL + "/assets/media/logo.png"}
                                            style={{ maxWidth: "200px" }} />
                                    </a>
                                </div>
                                <div className="row no-gutters justify-content-center">
                                    <div className="col-sm-8 col-xl-8">
                                        {route === 0 ? (
                                            <div>
                                                <p className="text-center text-uppercase text-muted">
                                                    Deseja se cadastrar como?
                                                </p>
                                                <button
                                                    onClick={() => processRoute(1)}
                                                    className="btn btn-warning btn-block"
                                                >
                                                    Usuário
                                                </button>
                                                <button
                                                    onClick={() => processRoute(2)}
                                                    className="btn btn-dark btn-block"
                                                >
                                                    Empresa
                                                </button>
                                                <button
                                                    type="submit"
                                                    className="btn btn-block mt-5 btn-dual"
                                                >
                                                    <i
                                                        className={
                                                            loading === true
                                                                ? "fa fa-circle-notch fa-spin"
                                                                : "fa fa-fw fa-sign-in-alt mr-1"
                                                        }
                                                    />{" "}
                                                    Já tem conta? Login
                                                </button>
                                            </div>
                                        ) : (
                                            ""
                                        )}
                                        {route !== 0 && steps()}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div
                            className="hero-static col-md-6 d-none d-md-flex align-items-md-center justify-content-md-center text-md-center bg-image"
                            style={{
                                backgroundImage: "url('assets/media/photos/bg-intro.jpg')",
                            }}
                        >
                            <div className="p-3">
                                <p className="display-4 font-w700 text-white mb-3">
                                    Cadastro
                                </p>
                                <p className="font-size-lg font-w600 text-white-75 mb-0">
                                    Reclame Rio &copy;{" "}
                                    <span className="js-year-copy">
                                        {new Date().getFullYear()}
                                        -Desenvolvido pela{" "}
                                        <a
                                            className="text-white"
                                            href="https://navigate.one"
                                            target="_blank" rel="noreferrer"
                                        >
                                            Navigate
                                        </a>
                                    </span>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </main>
            <ToastContainer className="toastr" />
        </div>
    );
}
